import React from 'react';
import styles from './styles.module.css';

type Props = {
  active?: boolean;
  title: string;
  number?: number;
  onButtonClick: () => void;
};

const FilterListItem: React.FC<Props> = ({ active, title, number, onButtonClick }: Props) => {
  return (
    <button className={`${styles.main} ${active ? styles.active : ''}`} onClick={onButtonClick}>
      <div className={`${styles.text}`}>{title}</div>
      {!!number && <div className={`${styles.number}`}>{number ?? 0}</div>}{' '}
    </button>
  );
};

export default FilterListItem;
